module.exports = __webpack_public_path__ + "resources/img/img_tcc_advantage1_m.4e8638201c022c72d17d0d3090f9fb58.jpg";